export default {
  FormName: 'CompanyAddEditForm',
  FormTitle: 'Company'
};
